module.exports = __webpack_public_path__ + "media/images/filter-4533674b4714217eb85571af2d867916.svg";